import { render } from "./CRMAgentStickersComponent.vue.vue?vue&type=template&id=82b32e88"
import script from "./CRMAgentStickersComponent.vue.vue?vue&type=script&lang=js"
export * from "./CRMAgentStickersComponent.vue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__